import { FC, useState } from "react"
import { toast } from "react-toastify"
import { formatDateHour } from "../../helpers/date"
import { ChallengeSectionProps } from "../../pages/Challenge"
import { useChallenge } from "../../stores/challenge"
import Button from "../Button"
import Card from "../Card"
import Col from "../Col"
import EditChallengeForm from "../EditChallengeForm"
import Modal from "../Modal"
import Row from "../Row"

const ChallengeGeneral: FC<ChallengeSectionProps> = ({
  challenge
}) => {
  const setChallenge = useChallenge(state => state.setChallenge)
  const [editChallengeModalOpen, setEditChallengeModalOpen] = useState<boolean>(false)

  return (
    <>
      <div className="grid grid-cols-12 gap-x-10">
        <Col lg={6}>
          <Card>
            <div className="mb-4 italic">{challenge.description}</div>

            {/* TODO: htmlDescription */}

            <ul>
              {!challenge.training &&
                <>
                  <Row as="li" className="card__row" justify="between">
                    <div className="card__row-title">Inizio gara</div>

                    <div>{formatDateHour(challenge.startTimestamp)}</div>
                  </Row>

                  <Row as="li" className="card__row" justify="between">
                    <div className="card__row-title">Fine gara</div>

                    <div>{formatDateHour(challenge.endTimestamp)}</div>
                  </Row>

                  <Row as="li" className="card__row" justify="between">
                    <div className="card__row-title">Inizio iscrizioni</div>

                    <div>{formatDateHour(challenge.startSubscriptionTimestamp)}</div>
                  </Row>

                  <Row as="li" className="card__row" justify="between">
                    <div className="card__row-title">Fine iscrizioni</div>

                    <div>{formatDateHour(challenge.endSubscriptionTimestamp)}</div>
                  </Row>

                  <Row as="li" className="card__row" justify="between">
                    <div className="card__row-title">Data di pubblicazione</div>

                    <div>{formatDateHour(challenge.visibleTimestamp)}</div>
                  </Row>

                  <Row as="li" className="card__row" justify="between">
                    <div className="card__row-title">Accessibilità</div>

                    <div>{challenge.private ? "Privata" : "Pubblica"}</div>
                  </Row>
                </>
              }

              <Row as="li" className="card__row" justify="between">
                <div className="card__row-title">Difficoltà</div>

                <div>{challenge.difficulty}</div>
              </Row>

              <Row as="li" className="card__row" justify="between">
                <div className="card__row-title">Punteggio Massimo</div>

                <div>{challenge.maxScore}</div>
              </Row>
            </ul>

            <Row justify="center" className="mt-4">
              <Button
                onClick={(): void => {
                  setEditChallengeModalOpen(true)
                }}
              >Modifica</Button>
            </Row>
          </Card>
        </Col>
      </div>

      {editChallengeModalOpen &&
        <Modal
          close={(): void => {
            setEditChallengeModalOpen(false)
          }}
          title="Modifica Challenge"
          className="challenge-modal"
        >
          <EditChallengeForm
            onSuccess={async(data): Promise<void> => {
              setChallenge(data)
              setEditChallengeModalOpen(false)
              toast.success("Dati aggiornati correttamente")
            }}
            defaultValues={challenge}
          />
        </Modal>
      }
    </>
  )
}

export default ChallengeGeneral
